import { render, staticRenderFns } from "./BubbleWording.vue?vue&type=template&id=3f9a2a87&scoped=true"
import script from "./BubbleWording.vue?vue&type=script&setup=true&lang=js"
export * from "./BubbleWording.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BubbleWording.vue?vue&type=style&index=0&id=3f9a2a87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9a2a87",
  null
  
)

export default component.exports